// AUTOGENERATED BY FUNCTION genubamodel.js
export interface DonationCommand extends CommandBase {
    data?: Donation;
    lineItems?: DonationLineItemPayload[];
}

export interface DonationLineItemCommand extends CommandBase {
    data?: DonationLineItem;
}

export interface ClientCauseCommand extends CommandBase {
    data?: ClientCause;
}

export interface Donation extends EntityBase {
    donationSource: DonationSourceType;
    donationType: DonationType;
    donationTransferType: DonationTransferType;
    fundsSourceType: FundsSourceType;
    fundsSourceId: string;
    givingAccountId?: string;
    frequency: FrequencyType;
    startDate?: string;
    endDate?: string;
    submissionDateTime?: string;
}

export interface DonationLineItem extends EntityBase, DonationLineItemPayload {}

export interface DonationLineItemPayload {
    id?: string;
    amount: number;
    destinationEntity: DestinationEntityType;
    destinationEntityId?: string;
    name: string;
}

export interface ClientCause extends EntityBase {
    name: string;
    startDate: string;
    endDate?: string;
    bureauId: string;
}

export interface ClientCauseContributions {
    employee: number;
    employer: number;
}

export interface ClientCauseDisbursements {
    total: number;
}

export interface DonationSummary {
    myCashDonationAmount?: number;
    givingAccountsDonationInfo?: GivingAccountDonationInfo[];
}

export interface GivingAccountDonationInfo {
    givingAccountId?: string;
    planName?: string;
    totalContributions?: number;
    totalDonations?: number;
}

export interface ClientCauseBalance {
    clientCauseId: string;
    balance: number;
    accountId: string;
}

export interface Criteria {
    key?: string;
    value?: string;
    matchType?: MatchType;
    chainType?: ChainType;
    groupCriteria?: GroupCriteria[];
}

export interface Error {
    message?: string;
    fields?: object;
}

export interface GroupCriteria {
    key?: string;
    value?: string;
    matchType?: MatchType;
    chainType?: ChainType;
}

export interface PingResponse {
    serverTime: ServerTime;
    services?: Service[];
}

export type SearchCriteria = Criteria[];

export type individualId = string;

export type ServerTime = string;

export interface Service {
    name?: string;
    serverTime?: string;
}

export type Donations = Donation[];

export type DonationLineItems = DonationLineItem[];

export type ClientCauses = ClientCause[];

export type ClientCauseBalances = ClientCauseBalance[];

export interface CommandBase {
    id?: string;
    eventCorrelationId?: string;
    jobId?: string;
    producerId?: string;
    sequenceId?: number;
    version?: number;
    type?: string;
    created?: string;
    createdBy?: string;
    createdById?: string;
}

export interface EntityBase {
    id?: string;
    parentId?: string;
    parentType?: ParentType;
    version?: number;
    created?: string;
    createdBy?: string;
    createdById?: string;
    updated?: string;
    updatedBy?: string;
    updatedById?: string;
    currentState?: string;
    lastTransition?: string;
    externalWorkflowId?: string;
    eventNotes?: string;
    transactionLockId?: string;
}

export enum DonationCommandType {
    StartToDonate = 'StartToDonate',
    DonateToDonated = 'DonateToDonated',
    DonateToScheduled = 'DonateToScheduled',
    DonateToPending = 'DonateToPending',
    PendingToDonated = 'PendingToDonated',
    PendingToCancelled = 'PendingToCancelled',
    ScheduledToCancelled = 'ScheduledToCancelled',
    PendingToRemoved = 'PendingToRemoved',
    DonatedToRemoved = 'DonatedToRemoved',
    ScheduledToRemoved = 'ScheduledToRemoved',
    CancelledToRemoved = 'CancelledToRemoved',
}

export enum DonationLineItemCommandType {
    StartToIncluded = 'StartToIncluded',
    IncludedToRemoved = 'IncludedToRemoved',
}

export enum ClientCauseCommandType {
    StartToInitiated = 'StartToInitiated',
    InitiatedToInitiated = 'InitiatedToInitiated',
    InitiatedToCancelled = 'InitiatedToCancelled',
    InitiatedToActive = 'InitiatedToActive',
    ActiveToActive = 'ActiveToActive',
    ActiveToInactive = 'ActiveToInactive',
    ActiveToClosed = 'ActiveToClosed',
    InactiveToInactive = 'InactiveToInactive',
    InactiveToActive = 'InactiveToActive',
    InactiveToClosed = 'InactiveToClosed',
    InitiatedToRemoved = 'InitiatedToRemoved',
    CancelledToRemoved = 'CancelledToRemoved',
    ActiveToRemoved = 'ActiveToRemoved',
    InactiveToRemoved = 'InactiveToRemoved',
    ClosedToRemoved = 'ClosedToRemoved',
}

export enum DonationState {
    Donate = 'Donate',
    Donated = 'Donated',
    Scheduled = 'Scheduled',
    Pending = 'Pending',
    Cancelled = 'Cancelled',
    Removed = 'Removed',
}

export enum DonationLineItemState {
    Included = 'Included',
    Removed = 'Removed',
}

export enum ClientCauseState {
    Initiated = 'Initiated',
    Cancelled = 'Cancelled',
    Active = 'Active',
    Inactive = 'Inactive',
    Closed = 'Closed',
    Removed = 'Removed',
}

export enum DonationSourceType {
    Platform = 'Platform',
    Card = 'Card',
}

export enum DonationType {
    Charity = 'Charity',
    Cause = 'Cause',
}

export enum DonationTransferType {
    CardDonationFromIDAFToCharity = 'CardDonationFromIDAFToCharity',
    DonationFromIDAFToCharity = 'DonationFromIDAFToCharity',
    DonationFromIDAFToClientCause = 'DonationFromIDAFToClientCause',
    CardDonationFromIGAToCharity = 'CardDonationFromIGAToCharity',
    DonationFromIGAToCharity = 'DonationFromIGAToCharity',
    DonationFromIGAToClientCause = 'DonationFromIGAToClientCause',
    CardDonationFromIABToCharity = 'CardDonationFromIABToCharity',
    DonationFromIABToCharity = 'DonationFromIABToCharity',
    DonationFromIABToClientCause = 'DonationFromIABToClientCause',
}

export enum FundsSourceType {
    IAB = 'IAB',
    PPTAB = 'PPTAB',
}

export enum FrequencyType {
    OneTime = 'OneTime',
    Monthly = 'Monthly',
}

export enum DestinationEntityType {
    Charity = 'Charity',
    Cause = 'Cause',
    CardSwipe = 'CardSwipe',
}

export enum ParentType {
    INDIVIDUAL = 'INDIVIDUAL',
    CLIENT = 'CLIENT',
    DONATION = 'DONATION',
}

export enum ChainType {
    AND = 'AND',
    OR = 'OR',
}

export enum MatchType {
    CONTAINS = 'CONTAINS',
    EXACT = 'EXACT',
    NOT = 'NOT',
    IN = 'IN',
    NOT_IN = 'NOT_IN',
    NOT_CONTAINS = 'NOT_CONTAINS',
    STARTS_WITH = 'STARTS_WITH',
    NOT_STARTS_WITH = 'NOT_STARTS_WITH',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_EQUAL = 'LESS_THAN_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_EQUAL = 'GREATER_THAN_EQUAL',
    IS_NULL = 'IS_NULL',
}
